import '../style.css';
import { useState, useEffect, useRef } from 'react';
import SuccessfulUpload from './modal/SuccessfulUpload';
import malaysiaData from '../components/helpers/states.json';
import axios from 'axios';
import { bucketDb } from './helpers/Config.js';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import GoogleMap from 'google-maps-react-markers';
import Calendar from 'react-calendar';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import 'react-calendar/dist/MyCalendar.css';

const DefaultLocation = { lat: 4.156156, lng: 103.502969 };

function ScheduleEvent() {
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [title, setTitle] = useState("")
  const [organizer, setOrganizer] = useState("")
  const [agenda, setAgenda] = useState("")
  const [venue, setVenue] = useState("")
  const [registrationMethod, setRegistrationMethod] = useState("")
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState("");
  const [duitnowFile, setDuitnowFile] = useState("");
  const [uploadedDuitNowName, setUploadedDuitNowName] = useState("");
  const [fileLink, setFileLink] = useState("");
  const [errors, setErrors] = useState({});
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [location, setLocation] = useState(DefaultLocation);
  const [fileType, setFileType] = useState("");
  const [date, setDate] = useState(new Date());
  const [startTime, setStartTime] = useState('10:00');
  const [endTime, setEndTime] = useState('11:00');
  const [link, setLink] = useState(""); 
  const [eventLocation, setEventLocation] = useState("");
  const [speakerName, setSpeakerName] = useState("")
  const [payment, setPayment] = useState("")
  const [registrationLink, setRegistrationLink] = useState("")
  const [prices, setPrices] = useState([
    { type: '', amount: '' },
    { type: '', amount: '' },
    { type: '', amount: '' },
    { type: '', amount: '' }
  ]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFile(file);
    if (file) {
      setUploadedFileName(file.name);
      setFileType(file.type.startsWith('image/') ? 'image' : 'video');
    }
  };

  const handleDuitNowUpload = (event) => {
    const file = event.target.files[0];
    setDuitnowFile(file);
    if (file) {
      setUploadedDuitNowName(file.name);
    }
  };

  const handleLatitudeChange = (event) => {
    const value = event.target.value;
    setLatitude(value);
  };
  
  const handleLongitudeChange = (event) => {
    const value = event.target.value;
    setLongitude(value);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const validateForm = () => {
    const newErrors = {};
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/; // Simple URL pattern

    if (!uploadedFileName) newErrors.file = "File is required";
    if (!payment) newErrors.payment = "Payment Method is required";
    if (payment === 'onUs') {
      if (!uploadedDuitNowName) newErrors.duitnowFile = "Duitnow QR is required";
    }
    if (!title) newErrors.title = "Title is required";
    if (!organizer) newErrors.organizer = "Organizer is required";
    if (!speakerName) newErrors.speakerName = "Speaker's Name is required";
    if (!date) newErrors.date = "Date is required";
    if (!startTime) newErrors.startTime = "Time is required";
    if (!endTime) newErrors.endTime = "Time is required";
    if (!payment) newErrors.payment = 'Payment Method is required';

    if (registrationMethod === 'offUs') {
      if (!registrationLink) newErrors.registrationLink = 'Registration Link is required'
    }

    if (payment === 'onUs'){
      if (!duitnowFile) newErrors.duitnow = 'DuitNow QR is required';
    }

    if (venue === 'physical') {
      if (!eventLocation) newErrors.eventLocation = "Event Location is required";
    }

    // Validate prices
    // if (!prices.some(price => price.type && price.amount)) {
    //   newErrors.prices = "At least one price category is required";
    // }
    // if (prices.some(price => (price.type && !price.amount) || (!price.type && price.amount))) {
    //   newErrors.prices = "Both type and amount are required for each price category";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpload = () => {
    setIsLoading(true);

    const savedUser = JSON.parse(localStorage.getItem('user'));
    const userId = savedUser ? savedUser.user._id : null;

    const fileRef = ref(bucketDb, `events/${uploadedFileName}`);
    const duitnowRef = ref(bucketDb, `events/duitnowqr/${uploadedDuitNowName}`)

    if (payment === 'offUs' || payment === null) {
      if (uploadedFileName && validateForm()) {
        uploadBytes(fileRef, file)
          .then(uploadResult => {
            return getDownloadURL(uploadResult.ref);
          })
          .then(url => {
            console.log(url);
            setFileLink(url);

            const eventData = {
              title: title,
              imgSrc: url,
              type: fileType,
              userId: userId,
              organizer: organizer,
              speakerName: speakerName,
              agenda: agenda,
              date: date,
              startTime: startTime,
              endTime: endTime,
              venue: venue,
              prices: prices.filter(price => price.type && price.amount),
              eventLocation: eventLocation,
              paymentMethod: payment,
              registrationMethod: registrationMethod,
              link: link,
              registrationLink: registrationLink,
              lat: latitude.toString(),
              long: longitude.toString(),
              participant: [],
            };

            return axios.post('https://geoid-rest.vercel.app/events', eventData);
          })
          .then(response => {
            console.log('Upload Response:', response.data);
            setShowModal(true);
            // Reset form fields
            setTitle("")
            setOrganizer("")
            setVenue("")
            setAgenda("")
            setDate("")
            setStartTime("")
            setEndTime("")
            setPrices([
              { type: 'Student', amount: '' },
              { type: 'Member', amount: '' },
              { type: 'Non-Member', amount: '' },
              { type: '', amount: '' }
            ]);
            setFile("");
            setUploadedFileName("");
            setLink("")
            setEventLocation("")
            setFileLink("");
            setFileType("");
            setSpeakerName("")
            setPayment("")
            setDuitnowFile("")
            setUploadedDuitNowName("")
          })
          .catch(error => {
            console.error('Error:', error);
            setErrorMessage(error.response?.data || 'An error occurred');
            setIsErrorModalOpen(true);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    } 
    else if (payment === 'onUs') {
      if (uploadedDuitNowName && uploadedFileName && validateForm()) {
        uploadBytes(duitnowRef, duitnowFile)
        .then(uploadResult => {
          return getDownloadURL(uploadResult.ref)
        }).then(duitnowURL => {
          uploadBytes(fileRef, file)
          .then(uploadResult => {
            return getDownloadURL(uploadResult.ref);
          })
          .then(url => {
            console.log(url);
            setFileLink(url);

            const eventData = {
              title: title,
              imgSrc: url,
              type: fileType,
              userId: userId,
              organizer: organizer,
              speakerName: speakerName,
              agenda: agenda,
              date: date,
              startTime: startTime,
              endTime: endTime,
              venue: venue,
              prices: prices.filter(price => price.type && price.amount),
              eventLocation: eventLocation,
              paymentMethod: payment,
              registrationMethod: registrationMethod,
              duitnowURL: duitnowURL,
              link: link,
              registrationLink: registrationLink,
              lat: latitude.toString(),
              long: longitude.toString(),
              participant: [],
            };

            return axios.post('https://geoid-rest.vercel.app/events', eventData);
          })
          .then(response => {
            console.log('Upload Response:', response.data);
            setShowModal(true);
            // Reset form fields
            setTitle("")
            setOrganizer("")
            setVenue("")
            setAgenda("")
            setDate("")
            setStartTime("")
            setEndTime("")
            setPrices([
              { type: 'Student', amount: '' },
              { type: 'Member', amount: '' },
              { type: 'Non-Member', amount: '' },
              { type: '', amount: '' }
            ]);
            setFile("");
            setUploadedFileName("");
            setLink("")
            setEventLocation("")
            setFileLink("");
            setFileType("");
            setSpeakerName("")
            setPayment("")
            setDuitnowFile("")
            setUploadedDuitNowName("")
          })
          .catch(error => {
            console.error('Error:', error);
            setErrorMessage(error.response?.data || 'An error occurred');
            setIsErrorModalOpen(true);
          })
          .finally(() => {
            setIsLoading(false);
          });
        })
      }
    }
  };
  
  const [mapLoaded, setMapLoaded] = useState(false);
  const mapRef = useRef(null);

  const handleMapLoad = (map) => {
    mapRef.current = map;
    setMapLoaded(true);
  };

  const Marker = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
      </svg>
    );
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handlePriceChange = (index, field, value) => {
    const newPrices = [...prices];
    if (field === 'amount') {
      // Only allow numbers and decimal points for amount
      if (!/^\d*\.?\d*$/.test(value) && value !== '') return;
    }
    newPrices[index][field] = value;
    setPrices(newPrices);
  };

  const formatPriceAmount = (index) => {
    const newPrices = [...prices];
    const amount = newPrices[index].amount;
    if (amount) {
      newPrices[index].amount = parseFloat(amount).toFixed(2);
      setPrices(newPrices);
    }
  };

  return (
    <div className="upload-container">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner">Loading...</div>
        </div>
      )}
      <h1>Schedule Event</h1>
      <div className="upload-content">
        <div className="upload-box">
          <input
            type="file"
            id="file-upload"
            className="file-input"
            onChange={handleFileUpload}
            accept="image/*,video/*"
          />
          <label htmlFor="file-upload" className="file-upload-label">
            <div className="upload-box-content">
              <div className="upload-icon">&#8593;</div>
              <p>
              <span className="browse-link">Browse</span> Image
              </p>
              <p className="supported-formats">
                Supported formats: JPG, PNG, GIF, etc.
              </p>
            </div>
          </label>
          {uploadedFileName && (
            <div className="uploaded-file">
              <span>{uploadedFileName}</span>
              <button onClick={() => setUploadedFileName("")}>❌</button>
            </div>
          )}
        </div>
        <div className="form-container">
          <div className="form-group">
            <label>Event Title <span className="required">*</span></label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
            {errors.name && <p className="error-text">{errors.name}</p>}
          </div>
          <div className="form-group">
            <label>Organizer<span className="required">*</span></label>
            <input type="text" value={organizer} onChange={(e) => setOrganizer(e.target.value)} />
            {errors.organizer && <p className="error-text">{errors.organizer}</p>}
          </div>
          <div className="form-group">
            <label>Speaker's Name<span className="required">*</span></label>
            <input type="text" value={speakerName} onChange={(e) => setSpeakerName(e.target.value)} />
            {errors.speakerName && <p className="error-text">{errors.speakerName}</p>}
          </div>
          <div className="form-group">
            <label>Agenda / Info of Event <span className="required">*</span></label>
            <textarea
              placeholder="Enter agendas for the event"
              value={agenda}
              onChange={(e) => setAgenda(e.target.value)}
              rows="4"
            />
            {errors.agenda && <p className="error-text">{errors.agenda}</p>}

            <label>Select Date <span className="required">*</span></label>
            <input
                type="text"
                value={date instanceof Date ? date.toLocaleDateString() : ''}
                readOnly
                className="date-input"
            />
            <Calendar
              onChange={setDate}
              value={date}
              className="calendar"
              style={{ width: '100%' }}
            />

            <label>Start Time <span className="required">*</span></label>
            <input aria-label="Time" type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)}/>

            <label>End Time <span className="required">*</span></label>
            <input aria-label="Time" type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)}/>

            <div className="form-group">
              <label>Registration</label>
              <div style={{display: 'flex', width: '100%', justifyContent: 'space-evenly'}}>
                  <label>
                      <input
                          type="radio"
                          value="onUs"
                          checked={registrationMethod === "onUs"}
                          onChange={(e) => setRegistrationMethod(e.target.value)}
                      />
                      In GeoIDly
                  </label>
                  <label>
                      <input
                          type="radio"
                          value="offUs"
                          checked={registrationMethod === "offUs"}
                          onChange={(e) => setRegistrationMethod(e.target.value)}
                      />
                      Outside GeoIDly
                  </label>
              </div>
              {errors.venue && <p className="error-text">{errors.venue}</p>}
            </div>

            {registrationMethod === 'offUs' &&(
            <div className="form-group">
              <label>Registration Link <span className="required">*</span></label>
              <input 
                type="text" 
                value={registrationLink}
                onChange={(e) => setRegistrationLink(e.target.value)}
                placeholder="Enter a valid URL"
              />
              {errors.registrationLink && <p className="error-text">{errors.registrationLink}</p>}
            </div>
            )}

            <div className="form-group">
              <label>Payment</label>
              <div style={{display: 'flex', width: '100%', justifyContent: 'space-evenly'}}>
                  <label>
                      <input
                          type="radio"
                          value="onUs"
                          checked={payment === "onUs"}
                          onChange={(e) => setPayment(e.target.value)}
                      />
                      In GeoIDly
                  </label>
                  <label>
                      <input
                          type="radio"
                          value="offUs"
                          checked={payment === "offUs"}
                          onChange={(e) => setPayment(e.target.value)}
                      />
                      Outside GeoIDly
                  </label>
              </div>
              {errors.payment && <p className="error-text">{errors.payment}</p>}
            </div>

            <div className="form-group">
              <label>Prices</label>
              {prices.map((price, index) => (
                <div key={index} style={{display: 'flex', gap:'10px', marginBottom: '10px'}}>
                  <input
                    type="text"
                    style={{width: '40%'}}
                    placeholder="Price Category"
                    value={price.type}
                    onChange={(e) => handlePriceChange(index, 'type', e.target.value)}
                  />
                  <input
                    type="text"
                    style={{width: '40%'}}
                    placeholder="Amount (RM)"
                    value={price.amount}
                    onChange={(e) => handlePriceChange(index, 'amount', e.target.value)}
                    onBlur={() => formatPriceAmount(index)}
                  />
                </div>
              ))}
              {errors.prices && <p className="error-text">{errors.prices}</p>}
            </div>
          </div>

          {payment === 'offUs' &&(
            <div className="form-group">
              <label>Payment Link</label>
              <input 
                type="text" 
                value={link}
                onChange={(e) => setLink(e.target.value)}
                placeholder="Enter a valid URL"
              />
              {errors.link && <p className="error-text">{errors.link}</p>}
            </div>
          )}

          {payment === 'onUs' &&(
            <div className="form-group">
              <label>Upload DuitNow QR Image <span className="required">*</span></label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleDuitNowUpload(e)} // Assuming handleFileUpload can handle this
              />
              {errors.duitnow && <p className="error-text">{errors.duitnow}</p>}
            </div>
          )}

          <div className="form-group">
              <label>Venue</label>
              <div style={{display: 'flex', width: '100%', justifyContent: 'space-evenly'}}>
                  <label>
                      <input
                          type="radio"
                          value="online"
                          checked={venue === "online"}
                          onChange={(e) => setVenue(e.target.value)}
                      />
                      Online
                  </label>
                  <label>
                      <input
                          type="radio"
                          value="physical"
                          checked={venue === "physical"}
                          onChange={(e) => setVenue(e.target.value)}
                      />
                      Physical
                  </label>
              </div>
              {errors.venue && <p className="error-text">{errors.venue}</p>}
          </div>

          {venue === 'physical' &&(
            <div className="form-group">
              <label>Location <span className="required">*</span></label>
              <input 
                type="text" 
                value={eventLocation}
                onChange={(e) => setEventLocation(e.target.value)}
                placeholder="Enter a Location"
              />
              {errors.eventLocation && <p className="error-text">{errors.eventLocation}</p>}
            </div>
          )}

          <div className="form-group">
            <label>Coordinate</label>
            <div className="coordinate-container">
              <div className="coordinate-item">
                <span className="coordinate-label">Lat</span>
                <input
                  type="text"
                  placeholder="Latitude"
                  value={latitude}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^-?\d*\.?\d*$/.test(value)) {
                      setLatitude(value);
                      if (value) {
                        setLocation({ ...location, lat: parseFloat(value) });
                      }
                    }
                  }}
                />
                {errors.latitude && <p className="error-text">{errors.latitude}</p>}
              </div>
              <div className="coordinate-item">
                <span className="coordinate-label">Long</span>
                <input
                  type="text"
                  placeholder="Longitude"
                  value={longitude}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^-?\d*\.?\d*$/.test(value)) {
                      setLongitude(value);
                      if (value) {
                        setLocation({ ...location, lng: parseFloat(value) });
                      }
                    }
                  }}
                />
                {errors.longitude && <p className="error-text">{errors.longitude}</p>}
              </div>
            </div>
            <div className='form-group'>
              <div className='map-container'>
                <GoogleMap
                  defaultCenter={{ lat: 4.156156, lng: 103.502969 }}
                  onGoogleApiLoaded={({ map, maps }) => handleMapLoad(map, maps)}
                  defaultZoom={7}
                  style={{ height: '100%', width: '100%' }}
                  apiKey=''
                //   center={location}
                >
                  <Marker
                    draggable={true}
                    lat={parseFloat(latitude) || location.lat}
                    lng={parseFloat(longitude) || location.lng}
                    onDragEnd={(e, { latLng }) => {
                      setTimeout(() => {
                        setLatitude(latLng.lat)
                        setLongitude(latLng.lng)
                        setLocation(latLng);
                      }, 1000);
                    }}
                  />
                </GoogleMap>
              </div>
            </div>
          </div>
          <button className="upload-button" onClick={handleUpload}>Schedule</button>
        </div>
      </div>

      {showModal && (
        <SuccessfulUpload message="Event scheduled successfully!" onClose={closeModal} />
      )}

      {/* Error Modal */}
      {isErrorModalOpen && (
        <div className="modal-register">
          <div className="modal-content-register">
            <h2>Error</h2>
            <p>{errorMessage}</p>
            <button className="modal-button-register" onClick={closeErrorModal}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ScheduleEvent;